<div
  class="section-menu__section"
  (click)="emitEvent()"
  [class.section-menu__section--active]="isActiveSection"
  [class.section-menu__section--complete]="isCompleted"
>
  <span class="section-menu__section-name">{{ sectionName }}</span>
  <div *ngIf="!shouldHideProgress" class="section-menu__progress-container">
    <div class="section-menu__progress" [style.width]="progressPercentage + '%'"></div>
  </div>
  <div
    *ngIf="!shouldHideProgress"
    class="section-menu__checkmark"
    [class.section-menu__checkmark--hidden]="!isCompleted"
  ></div>

  <!--SECTION ERROR-->
  <div *ngIf="isError" class="section-menu__progress-container">
    <div class="section-menu__progress" [style.width]="'0%'"></div>
  </div>
  <div *ngIf="isError" class="section-menu__error" [class.section-menu__error--hidden]="!isError"></div>
  <!------->
</div>
